// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__b6-UZ","name":"ConsentHeader_name__2MFDG","birthday":"ConsentHeader_birthday__139DU","skeleton":"ConsentHeader_skeleton__3K8IQ"};